export const networks = [
  {
    chainId: 'rebel-2',
    faucetUrl: 'https://rpc.terra-classic.hexxagon.dev/claim',
  },
];
